import {EventType, EventKind} from 'services/analytics/const';
import {buildEventCreator} from 'services/analytics';

type PlainEventName = EventKind.CancelSpend;

export function createSimpleEvent(name: PlainEventName): EventFactory<never> {
  return buildEventCreator<EventType.Plain>({name});
}

export const createCancelSpendEvent = createSimpleEvent(EventKind.CancelSpend);
